import { SAVE_PAGE, SAVE_PAGE_SUCCESS, SAVE_PAGE_FAILURE } from './actionTypes';

const initialState = {
  isSaving: false,
  page: {},
  error: []
};

export const newPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_PAGE:
      return { ...state, isSaving: true };
    case SAVE_PAGE_SUCCESS:
      return { ...state, isSaving: false, page: action.payload };
    case SAVE_PAGE_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newPage.isSaving;
export const getPage = state => state.newPage.page;
export const getError = state => state.newPage.error;



// WEBPACK FOOTER //
// ./src/modules/PageForm/reducer.js